import { isProduction } from "@/libraries/signup/bxpkit-core";

export function useBacDeepUrl(
    isLoggedIn: boolean,
    defaultUnitCount: number,
    unitCount: number,
    pricingPlanId: string
) {
    return isLoggedIn
        ? getBacDeepUrl(defaultUnitCount, unitCount, pricingPlanId)
        : getBacDeepUrlForSignup(defaultUnitCount, unitCount, pricingPlanId);
}

const getBacDeepUrl = (
    defaultUnitCount: number,
    unitCount: number,
    pricingPlanId: string
) => {
    if (typeof window === "undefined") {
        return "https://www.atlassian.com";
    }
    const baseUrl = isProduction()
        ? "https://www.atlassian.com"
        : "https://wac.stg.internal.atlassian.com";

    const usersQueryParam =
        defaultUnitCount === unitCount ? "" : `&users=${unitCount}`;

    const queryParams = `place-order?pricingPlanId=${pricingPlanId}${usersQueryParam}`;

    return `${baseUrl}/purchase/cloudcart/${queryParams}`;
};

const getBacDeepUrlForSignup = (
    defaultUnitCount: number,
    unitCount: number,
    pricingPlanId: string
) => {
    if (typeof window === "undefined") {
        return "https://id.atlassian.com";
    }
    const continueBacUrl = getBacDeepUrl(
        defaultUnitCount,
        unitCount,
        pricingPlanId
    );

    const baseUrl = isProduction()
        ? "https://id.atlassian.com"
        : "https://id.stg.internal.atlassian.com";

    return `${baseUrl}/login?continue=${encodeURIComponent(continueBacUrl)}`;
};
